import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const StudentMenu = () => {
  const routes = all_routes;

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Menu</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="card bg-info">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-white">
                      <h3>Student Menu</h3>
                      <p>Access all academic features and settings</p>
                    </div>
                    <div className="avatar avatar-lg">
                      <i className="ti ti-menu-2 text-white fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Profile Section */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">
                    <i className="ti ti-user me-2"></i>
                    Profile Section
                  </h5>
                </div>
                <div className="card-body">
                  <Link
                    to={routes.profile}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-primary-transparent me-3">
                      <i className="ti ti-user text-primary"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">View/Edit Profile</h6>
                      <p className="text-muted mb-0">
                        Manage personal information
                      </p>
                    </div>
                  </Link>
                  <Link
                    to={routes.studentSettings}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-secondary-transparent me-3">
                      <i className="ti ti-settings text-secondary"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Account Settings</h6>
                      <p className="text-muted mb-0">
                        Notifications, language, theme
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Academic & Daily Pages */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">
                    <i className="ti ti-book me-2"></i>
                    Academic & Daily Pages
                  </h5>
                </div>
                <div className="card-body">
                  <Link
                    to={routes.attendanceView}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-success-transparent me-3">
                      <i className="ti ti-calendar-check text-success"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Attendance History</h6>
                      <p className="text-muted mb-0">
                        Detailed attendance records with filters
                      </p>
                    </div>
                  </Link>
                  <Link
                    to={routes.studentTimeTable}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-primary-transparent me-3">
                      <i className="ti ti-calendar text-primary"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Full Schedule</h6>
                      <p className="text-muted mb-0">
                        Weekly/monthly view, exam dates, holidays
                      </p>
                    </div>
                  </Link>
                  <Link
                    to={routes.homeworkList}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-warning-transparent me-3">
                      <i className="ti ti-book-2 text-warning"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Homework History</h6>
                      <p className="text-muted mb-0">
                        Past assignments & submission status
                      </p>
                    </div>
                  </Link>
                  <Link
                    to={routes.gradeList}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-info-transparent me-3">
                      <i className="ti ti-trophy text-info"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Grades & Exam Overview</h6>
                      <p className="text-muted mb-0">
                        Filters, trends, teacher comments
                      </p>
                    </div>
                  </Link>
                  <Link
                    to={routes.studentEvents}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-danger-transparent me-3">
                      <i className="ti ti-calendar-event text-danger"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Events Calendar</h6>
                      <p className="text-muted mb-0">
                        School holidays & events
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Communication */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">
                    <i className="ti ti-message me-2"></i>
                    Communication
                  </h5>
                </div>
                <div className="card-body">
                  <Link
                    to={routes.studentMessages}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-primary-transparent me-3">
                      <i className="ti ti-mail text-primary"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Messages</h6>
                      <p className="text-muted mb-0">
                        Contact teachers or admin
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Notifications */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">
                    <i className="ti ti-bell me-2"></i>
                    Notifications
                  </h5>
                </div>
                <div className="card-body">
                  <Link
                    to={routes.studentNotifications}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-warning-transparent me-3">
                      <i className="ti ti-bell text-warning"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Notifications</h6>
                      <p className="text-muted mb-0">
                        Past alerts and system messages
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Tasks / Assignments */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">
                    <i className="ti ti-clipboard-list me-2"></i>
                    Tasks / Assignments
                  </h5>
                </div>
                <div className="card-body">
                  <Link
                    to={routes.todoList}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-info-transparent me-3">
                      <i className="ti ti-list-check text-info"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">To-Do List</h6>
                      <p className="text-muted mb-0">
                        Homework, projects, and exams
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Help & Logout */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">
                    <i className="ti ti-help me-2"></i>
                    Support
                  </h5>
                </div>
                <div className="card-body">
                  <Link
                    to={routes.studentHelp}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
                  >
                    <div className="avatar avatar-sm bg-success-transparent me-3">
                      <i className="ti ti-help text-success"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Help / FAQ</h6>
                      <p className="text-muted mb-0">Get support & answers</p>
                    </div>
                  </Link>
                  <button className="btn btn-danger w-100">
                    <i className="ti ti-logout me-2"></i>
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentMenu;
